import { Phone, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export const TextToRentCTA = () => {
  return (
    <a
      href="sms:8592703755?body=car%20rental"
      className="sticky-cta"
      data-testid="sticky-cta"
    >
      <Button
        size="lg"
        className="bg-amber-500 hover:bg-amber-600 text-black font-bold rounded-full shadow-2xl px-6 py-6 animate-bounce-slow"
      >
        <MessageSquare className="w-5 h-5 mr-2" />
        Text to Book
      </Button>
    </a>
  );
};

export const TextToRentBanner = () => {
  return (
    <section className="bg-primary text-white section-padding" data-testid="text-to-rent-banner">
      <div className="container-custom text-center">
        <h2 className="font-heading font-bold text-3xl md:text-4xl mb-4">
          Ready to Get on the Road?
        </h2>
        <p className="text-primary-foreground/80 max-w-xl mx-auto mb-8 text-lg">
          Text "car rental" to book your vehicle. No credit checks. 
          No deposit. Unlimited in-town mileage.
        </p>
        <a href="sms:8592703755?body=car%20rental" data-testid="banner-cta">
          <Button
            size="lg"
            className="bg-white text-primary hover:bg-slate-100 uppercase tracking-wide font-bold text-lg px-10 py-6 btn-brutalist"
          >
            <Phone className="w-5 h-5 mr-3" />
            Text (859) 270-3755
          </Button>
        </a>
        <p className="text-primary-foreground/60 text-sm mt-4">
          Text "car rental" to get started
        </p>
      </div>
    </section>
  );
};
